/* tslint:disable */
import { Log } from 'ng2-logger';
import React from 'react';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';

const _logger = Log.create('Processing Activity');
const T = Translator.create();
let _common: Common;

interface UpdateModalProps {
    selectedItem: any;
    onChangeText: (e: any) => void;
}


const UpdateModal: React.FC<UpdateModalProps> = (props) => {
    _common = new Common();

    return (
        <>
            <div className="info-box mt-2">
                <p>{T.t('r_updating_learning_outcome')}</p>
            </div>
            <div className="form-input form-group note-pad mb-0">
                <input
                    id="bulkGradeInput"
                    onChange={(e: any) => { props.onChangeText(e.target.value) }}
                    type="text"
                    placeholder={T.t('r_create_new_text')}
                    defaultValue={props?.selectedItem?.learningOutcomeValue}
                />
            </div>
        </>
    );
};


export default UpdateModal;